import { operatingCountries } from 'constants/user';

const canadianOpcos = APP_CONFIG.canadianOpcos || '';

/**
 * Derive the country of the user from Opco ID
 *
 * @param {*} opcoId
 * @returns country
 */
export const getCountryOfUser = (opcoId) => {
  return canadianOpcos.split(',').includes(opcoId) ?
  operatingCountries.canada : operatingCountries.unitedStates;
};
